module.exports = __webpack_public_path__ + "img/拉伸2.aa518743.svg";